module.exports = {"542521100":"普兰镇","542521200":"巴嘎乡","542521201":"霍尔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542521.json
// module id = 2905
// module chunks = 0